// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function MM_cmp_rename_tab(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var initName = props.initName;
  var match = React.useState(function () {
        return initName;
      });
  var setNewName = match[1];
  var newName = match[0];
  var actOk = function () {
    onOk(newName);
  };
  var actCancel = function () {
    onCancel();
  };
  var rndTextField = function () {
    return React.createElement(TextField, {
                value: newName,
                label: "Tab title",
                size: "small",
                style: {
                  width: "500px"
                },
                onChange: Expln_React_common.evt2str(function (str) {
                      setNewName(function (param) {
                            return str;
                          });
                    }),
                onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actOk), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actCancel)),
                autoFocus: true
              });
  };
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                style: {
                  padding: "4px"
                },
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onOk(newName);
                      }),
                    variant: "contained",
                    children: "Save"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    children: "Cancel"
                  }));
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              children: Caml_option.some(null)
            }, rndTextField(), rndButtons());
}

var make = MM_cmp_rename_tab;

exports.make = make;
/* react Not a pure module */
